import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.checkRolesModulos().pipe(
      map((accesos) => {
        if (accesos.debe_cambiar_password) {
          return this.router.createUrlTree(['/cambiar-password']);
        }

        return true;
      }),
      catchError(() => of(this.router.createUrlTree(['/login']))),
    );
  }
}
